/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Description_PlaceholderInputs */

const en_image_export_description_placeholder = /** @type {(inputs: Image_Export_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English Subtitles`)
};

const fr_image_export_description_placeholder = /** @type {(inputs: Image_Export_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-titres anglais`)
};

const de_image_export_description_placeholder = /** @type {(inputs: Image_Export_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Englische Untertitel`)
};

const it_image_export_description_placeholder = /** @type {(inputs: Image_Export_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottotitoli in inglese`)
};

const ru_image_export_description_placeholder = /** @type {(inputs: Image_Export_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Английские субтитлы`)
};

const es_image_export_description_placeholder = /** @type {(inputs: Image_Export_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtítulos en inglés`)
};

const zh_cn2_image_export_description_placeholder = /** @type {(inputs: Image_Export_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`英文字幕`)
};

const ja_image_export_description_placeholder = /** @type {(inputs: Image_Export_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`英語字幕`)
};

const hi_image_export_description_placeholder = /** @type {(inputs: Image_Export_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंग्रेजी में उपशीर्षक`)
};

const pt_pt2_image_export_description_placeholder = /** @type {(inputs: Image_Export_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendas em inglês`)
};

/**
* | output |
* | --- |
* | "English Subtitles" |
*
* @param {Image_Export_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_description_placeholder = /** @type {((inputs?: Image_Export_Description_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Description_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_description_placeholder(inputs)
	if (locale === "de") return de_image_export_description_placeholder(inputs)
	if (locale === "it") return it_image_export_description_placeholder(inputs)
	if (locale === "ru") return ru_image_export_description_placeholder(inputs)
	if (locale === "es") return es_image_export_description_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_description_placeholder(inputs)
	if (locale === "ja") return ja_image_export_description_placeholder(inputs)
	if (locale === "hi") return hi_image_export_description_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_description_placeholder(inputs)
	return en_image_export_description_placeholder(inputs)
});